import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { AniSlideUp } from '@/components/shared/animations/basic';

import { useIndustrialFasteningPoints } from '../useIndustrialPageData';

/**
 * ### IndustrialFasteningPoints
 *
 * Names the fastening defects the connector engagement inspection catches,
 * one at a time, with the sound cue that gives each away.
 *
 * Rendered as a sub-block of {@link IndustrialFasteningSection}, so its
 * heading sits one level under a section title and its cards one level under
 * the page's own use-case cards.
 *
 * @returns The rendered defect list element
 * @see {@link useIndustrialFasteningPoints} The copy rendered here
 */
export default function IndustrialFasteningPoints() {
  const { t } = useTranslation('common');
  const points = useIndustrialFasteningPoints(t);

  return (
    <div>
      <h3 className="text-[20px] font-bold leading-[140%] tracking-[-0.4px] text-apps-coreGrayWhite lg:text-[clamp(20px,1.875vw,26px)]">
        {t('ListenAI Click이 잡아내는 것')}
      </h3>
      <p className="mt-[8px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray600 lg:text-[18px] lg:leading-[160%] lg:tracking-[-0.36px]">
        {t(
          '작업자가 귀와 손끝 감각으로 판단하던 체결 상태를 같은 기준으로 매 제품 판정합니다',
        )}
      </p>
      {/*
        AniSlideUp 은 className 을 받지 않아 li 자체에 간격을 줄 수 없다.
        간격은 ul 이 쥐고(모바일 세로 스택 / lg 3열), 각 항목은 위쪽 구분선만
        그린다. IndustrialEvidenceSection 과 같은 처리다.
      */}
      <ul className="mt-[24px] flex flex-col gap-[20px] lg:mt-[32px] lg:grid lg:grid-cols-3 lg:gap-[32px]">
        {points.map((point, index) => (
          <AniSlideUp key={point.title} delay={0.2 * index} element="li">
            <div className="h-full border-t border-t-apps-brandGray50 pt-[20px]">
              <h4 className="text-[17px] font-bold leading-[140%] tracking-[-0.34px] text-apps-coreGrayWhite lg:text-[19px]">
                {point.title}
              </h4>
              <p className="mt-[8px] text-[15px] font-medium leading-[150%] tracking-[-0.3px] text-apps-brandGray600 lg:text-[16px] lg:leading-[160%]">
                {point.description}
              </p>
              <ul className="mt-[12px] inline-flex flex-wrap gap-[8px] text-[14px] font-medium leading-[150%] text-apps-brandGray600 lg:text-[15px]">
                {point.tags.map((tag) => (
                  <li key={tag}>#{tag}</li>
                ))}
              </ul>
            </div>
          </AniSlideUp>
        ))}
      </ul>
    </div>
  );
}
